export default "__VITE_ASSET__7be334d0__"